import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { connect } from "react-redux";

import config from "config";

import { loginUser } from "services/auth";
import { setUser } from "services/users";
import { setLoading } from "services/loading";

import {
  IonContent,
  IonButton,
  IonInput,
  IonLabel,
  IonItem,
} from "@ionic/react";

import Spacer from "components/spacer";
import { useToasts } from "components/Toast/toast";

interface props {
  loggedIn: any;
  setUser: any;
  setLoading: any;
}

const Login: React.FC<props> = ({ loggedIn, setUser, setLoading }) => {
  const history = useHistory();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");

  const { addToast } = useToasts();

  useEffect(() => {
    if (loggedIn) {
      history.replace("/");
    }
    //eslint-disable-next-line
  }, [loggedIn]);

  function login(e: any) {
    e.preventDefault();
    setLoading(true, "Logging in");
    loginUser({ username, password })
      .then((res: any) => {
        if (res && res.data) {
          // console.log(res);
          const customer = res.data;
          if (res) {
            setUser(customer);
            setTimeout(() => {
              history.push("/");
              addToast({
                message: "You are logged in!",
                color: "success",
              });
            }, 500);
          }
          setLoading(false);
        } else {
          if (res && res.status === 503) {
            addToast({
              message: "Network error - Check your network connection",
              color: "danger",
            });
          } else {
            addToast({
              message: "Invalid username or password",
              color: "danger",
            });
          }
          console.log(res);
          setLoading(false);
        }
      })
      .catch((err: any) => {
        console.log(err);
        setLoading(false);
        addToast("An error occurred", "danger");
      });
  }

  // if (!loggedIn)
  return (
    <IonContent fullscreen className="ion-padding auth-screen">
      <div className="page-wrapper app-background">
        <div id="app-logo">
          <img src={config.LOGO} alt="logo" />
        </div>
        <div id="content-box">
          <h1 className="center-text instructions">Login</h1>
          <form onSubmit={login}>
            <IonItem>
              <IonLabel position="floating">Username</IonLabel>
              <IonInput
                type="text"
                name="username"
                placeholder="Username"
                autocomplete="username"
                onIonChange={(e: any) => setUsername(e.target.value)}
              />
            </IonItem>
            <Spacer size="15" />
            <IonItem>
              <IonLabel position="floating">Password</IonLabel>
              <IonInput
                type="password"
                placeholder="Password"
                name="password"
                enterkeyhint="go"
                autocomplete="current-password"
                onIonChange={(e: any) => setPassword(e.target.value)}
              />
            </IonItem>
            <Spacer size="15" />
            <input
              type="submit"
              className="submit-enter"
              style={{ display: "none" }}
            />
            <IonButton expand="full" size="large" onClick={login}>
              Login
            </IonButton>
          </form>
          <Spacer size="15" />
          {/* <div
								onClick={() => history.push("/forgotpassword")}
								className="linked instructions small center-text"
							>
								Forgot your password?
							</div> */}
          {/* <Link
            to="/forgotpassword"
            className="instructions small full-width center-text"
          >
            Forgot your password?
          </Link> */}
        </div>
      </div>
    </IonContent>
  );
  // else return null;
};

const mapStateToProps = (state: any) => ({
  loggedIn: state.user.loggedIn,
});

export default connect(mapStateToProps, {
  setUser,
  setLoading,
})(Login);
